import * as types from '../action-types';

export default paymentOptionsLoadingStatus => ({
  type: types.SET_PAYMENT_OPTIONS_LOADING_STATUS,
  paymentOptionsLoadingStatus,
});
